import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
// img
import FooterLogoDark from "../../images/logo-footer-dark.svg";
import FooterLogoLight from "../../images/reshto-logo.png";
import { Link } from 'react-router-dom';
import { useTheme } from "../../contexts/ThemeContext";
import { motion } from 'framer-motion';

export default function Footer() {
    const { theme } = useTheme();
    return (
        <>
            <motion.footer initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='footer-section'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={10} lg={8} xl={5}>
                            <motion.div initial={{opacity: 0 ,y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='text-center text-xl-start mb-5 mb-xl-0 pe-xl-5'>
                                {
                                    theme === 'light' ? (
                                        <Image src={FooterLogoDark} alt="" className='d-block ms-xl-0 mx-auto' height={120} />
                                    ) : (
                                        <Image src={FooterLogoLight} alt="" className='d-block ms-xl-0 mx-auto' height={120} />
                                    )
                                }
                                <motion.p initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='text-muted mt-2 mb-4'>At Reshto, we believe that food is more than just a meal—it's an experience. Our passion lies in crafting culinary delights that bring people together, creating memories that linger long after the last bite.</motion.p>
                                <motion.h5 initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='fw-semibold'>Follow Us</motion.h5>
                                <motion.div initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='social-icons justify-content-center justify-content-xl-start'>
                                    <Link to="/" className='social-icon'><i className="ri-facebook-circle-fill"></i></Link>
                                    <Link to="/" className='social-icon'><i className="ri-twitter-fill"></i></Link>
                                    <Link to="/" className='social-icon'><i className="ri-linkedin-box-fill"></i></Link>
                                    <Link to="/" className='social-icon'><i className="ri-skype-fill"></i></Link>
                                </motion.div>
                            </motion.div>
                        </Col>
                        <Col xl={7}>
                            <Row>
                                <Col sm={6} md={4}>
                                    <motion.h5 initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}>About Us</motion.h5>
                                    <motion.div initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='footer-links'>
                                        <Link to="/" className='footer-link'>Our Reaturant</Link>
                                        <Link to="/" className='footer-link'>Investors Relations</Link>
                                        <Link to="/" className='footer-link'>FAQs</Link>
                                        <Link to="/" className='footer-link'>Customer Reviews</Link>
                                        <Link to="/" className='footer-link'>Social Stories</Link>
                                        <Link to="/" className='footer-link'>Careers</Link>
                                        <Link to="/" className='footer-link'>Food & Drinks</Link>
                                        <Link to="/" className='footer-link'>Pizza & Dessert</Link>
                                    </motion.div>
                                </Col>
                                <Col sm={6} md={4}>
                                    <motion.h5 initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}>Quick Links</motion.h5>
                                    <motion.div initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='footer-links'>
                                        <Link to="/" className='footer-link'>About Us</Link>
                                        <Link to="/" className='footer-link'>Special Menu</Link>
                                        <Link to="/" className='footer-link'>Online Delivery</Link>
                                        <Link to="/" className='footer-link'>Best Foods</Link>
                                        <Link to="/" className='footer-link'>Featured</Link>
                                        <Link to="/" className='footer-link'>Privacy & Policy</Link>
                                        <Link to="/" className='footer-link'>Payment Services</Link>
                                        <Link to="/" className='footer-link'>Resturant Services</Link>
                                    </motion.div>
                                </Col>
                                <Col md={4}>
                                    <motion.div initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='mt-4 mt-md-0'>
                                        <motion.h5 initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}>Reshto Info</motion.h5>

                                        <Link to="/" className='text-muted mb-4 d-block'>3667 Nutters Washington Barn, Way Mason City, IA 50401</Link>
                                        <p className='text-muted mb-1'>Monday - Sunday</p>
                                        <p className='text-muted mb-4'>08:00 AM - 12:00 PM</p>

                                        <Link to="mailto:JaySCoffman@teleworm.us" className='text-muted d-block mb-1' >JaySCoffman@teleworm.us</Link>
                                        <Link to="tel:(+01) 1234 5678 90" className='text-muted d-block mb-0' >(+01) 1234 5678 90</Link>
                                    </motion.div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <hr className='mt-md-5 mb-4' />
                    <Row>
                        <Col md={12}>
                            <motion.div initial={{opacity: 0, y: 20 }} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='d-md-flex justify-content-md-between text-center text-md-start'>
                                <p className='mb-2 mb-md-0 text-muted'>Copyright © {(new Date().getFullYear())} <Link to="https://mantrakshdevs.com" target="_blank" className='text-danger fw-medium'>Mantraksh Devs</Link>. Crafted with <i className="ri-heart-fill text-danger"></i></p>
                                <Link to="/" className='text-muted'>Term Condition & Policy</Link>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </motion.footer>
        </>
    )
}
